<script setup>
import { user } from '@/store';
import requests from '@dk.onlinefundraising/onboarding-utils/src/OfOnboardingRequests';
import { onMounted, ref, computed } from 'vue';
import OfSessionSummary from './OfSessionSummary.vue';
import OfSignupSessionForm from './OfSignupSessionForm.vue';
import OfUpgradeSessionForm from './OfUpgradeSessionForm.vue';
import OfModalMessage from "@dk.onlinefundraising/vue-utils/src/utils/OfModalMessage.vue";
import OfButton from '@dk.onlinefundraising/vue-utils/src/utils/OfButton.vue';
import OfInput from '@dk.onlinefundraising/vue-utils/src/utils/OfInput.vue';

const campaign = ref(null);
const client = ref(null)
const workflow = ref(null)
const subscriptionGuid = ref(null)
const subscriptionGuidInput = ref('')
const externalLeadId = ref(null)

const appUrl = computed(() => {
    return location.origin;
})
function defineExternalLeadId() {
    const href = window.location.href;

    window.location =
        href.replace("&externalLeadId=", "") +
        "&externalLeadId=" +
        getRandomString();
}
function getRandomString(length = 10) {
    var result = "";
    var characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
        result += characters.charAt(
            Math.floor(Math.random() * charactersLength)
        );
    }
    return result;
}
function setSubscription() {
    if (subscriptionGuidInput.value) {
        requests.getSubscription(subscriptionGuidInput.value.trim(), client.value.merchantId).then((result) => {
            if (result) {
                const href = window.location.href;

                window.location =
                    href.replace("&subscriptionGuid=", "").split("&")[0] +
                    "&subscriptionGuid=" +
                    subscriptionGuidInput.value;
            }
        })
    }
}
onMounted(() => {
    const urlParams = new URLSearchParams(window.location.search);

    const campaignGuid = urlParams.get('campaignGuid')
    subscriptionGuid.value = urlParams.get('subscriptionGuid')
    externalLeadId.value = urlParams.get('externalLeadId')

    requests.getCampaign(campaignGuid.trim()).then((result) => {
        campaign.value = result;

        requests.getMerchant(campaign.value.merchantId, user.value.agencyId).then((result) => {
            client.value = result;
        });

        requests.getWorkflow(campaign.value.workflowGuid).then((result) => {
            workflow.value = result;


            // Backwards compatibility
            if (workflow.value && workflow.value.signUpProducts) {
                workflow.value.signUpProducts.map((product) => {
                    if (!product.paymentMethodTypes) {

                        const paymentMethodTypes = [];

                        for (const [key, value] of Object.entries(product)) {

                            if (key.startsWith('paymentMethodType') && key != 'paymentMethodTypes' && value) {
                                paymentMethodTypes.push(key.replace('paymentMethodType', ''))
                            }
                            product.paymentMethodTypes = paymentMethodTypes;
                        }
                    }
                })
            }

        });

    });





})
</script>
<template>
    <main v-if="campaign && client && workflow" class="container ">

        <OfSessionSummary :agent="user.name" :client="client.name" :workflow="workflow" :campaign="campaign" />

        <template v-if="workflow.serviceType == 'Upgrade' && !subscriptionGuid">

            <OfModalMessage color="red">
                Subscription Guid is not defined.
            </OfModalMessage>

            <p>
                {{ `Please prepend the correct subscriptionGuid to your URL like so:
                ${appUrl}/onboard?campaignGuid=${campaign.campaignGuid}&` }}<span class="underline">{{ `subscriptionGuid={
                guid }` }}</span>
            </p>

            <div class="subscription-guid-form">
                <OfInput v-model="subscriptionGuidInput" type="text" placeholder="Subscription Guid" class="subscription-guid-form__input"/>
                <OfButton text="Load subscription" coloring="primary" @click="setSubscription()" class="subscription-guid-form__button"/>
            </div>

        </template>

        <template v-else-if="workflow.serviceType == 'SignUp' && !externalLeadId">
            <div class="session-notice">
                <OfModalMessage color="yellow">
                    External lead ID is not defined.
                </OfModalMessage>

                <p>
                    {{ `Please prepend a unique external ID per Lead to your URL like so:
                    ${appUrl}/onboard?campaignGuid=${campaign.campaignGuid}` }}<span class="underline">{{ `&externalLeadId={ ID }` }}</span>
                </p>

                <hr>

                <p>
                    If the lead is not registered elsewhere, you can proceed with a random external lead ID.
                </p>

                <OfButton text="Define a random external lead ID" coloring="primary" @click="defineExternalLeadId()" />
            </div>
        </template>

        <div v-else class="session-specification">

            <OfSignupSessionForm v-if="workflow.serviceType == 'SignUp'" :workflow="workflow" :campaign="campaign"
                :client="client" />

            <OfUpgradeSessionForm v-else-if="workflow.serviceType == 'Upgrade'" :workflow="workflow"
                :campaign="campaign" :client="client" />

        </div>

    </main>
</template>
<style scoped lang="scss">
main {
    padding-top: 30px;
    max-width: 800px;
    margin-right: auto;
    margin-left: auto;
    padding-left: 15px;
    padding-right: 15px;
}

p {
    margin: 20px 0;
}

.session-notice {
    padding-left: 15px;
    padding-right: 15px;
}

.session-specification {
    padding: 0 0 30px 0;
}
.subscription-guid-form {
    display: flex;
    gap: 10px;

    &__input {
        flex-grow: 1;

       :deep(>div) {
            width: 100%;
        }
    }
}
.underline {
    text-decoration: underline;
}
</style>